import { Link } from 'react-router-dom';

const SERVICES_LINKS = [
  { to: '/uslugi', label: 'Strony WWW Premium' },
  { to: '/uslugi', label: 'SEO & Pozycjonowanie' },
  { to: '/uslugi', label: 'Agenci AI' },
  { to: '/uslugi', label: 'Google Wizytówka' },
  { to: '/uslugi', label: 'Wirtualne Wycieczki 360°' },
  { to: '/uslugi', label: 'Oprogramowanie AI' },
];

const COMPANY_LINKS = [
  { to: '/o-nas', label: 'O nas' },
  { to: '/realizacje', label: 'Realizacje' },
  { to: '/proces', label: 'Proces' },
  { to: '/pakiety', label: 'Pakiety' },
  { to: '/blog', label: 'Blog' },
  { to: '/kontakt', label: 'Kontakt' },
];

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/5 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center mb-7 cursor-pointer group">
              <img
                src="https://storage.readdy-site.link/project_files/c74744eb-3995-40db-8fce-b59523b1b313/898a52d7-18aa-43c2-be1f-5134a7f25dee_ChatGPT-Image-24-mar-2026-07_22_57.png?v=a14bd4da0532dd836168e272800ed8fb"
                alt="Orsonet - Wdrożenia AI"
                className="h-16 w-auto object-contain opacity-85 group-hover:opacity-100 transition-all duration-300 group-hover:scale-[1.03]"
                style={{ maxWidth: '200px' }}
              />
            </Link>
            <p className="text-white/35 text-sm leading-relaxed mb-6">
              Wdrażamy nowoczesne technologie AI dla biznesu. Agenci AI, automatyzacje, strony premium i SEO dla wymagających klientów.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-facebook-fill', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 rounded-xl border border-white/10 flex items-center justify-center text-white/40 hover:text-[#00d4ff] hover:border-[#00d4ff]/30 transition-all cursor-pointer"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white/30 text-xs uppercase tracking-[2px] font-semibold mb-5">Usługi</h4>
            <ul className="space-y-3">
              {SERVICES_LINKS.map((l, i) => (
                <li key={`${l.to}-${i}`}>
                  <Link
                    to={l.to}
                    className="text-white/45 hover:text-[#00d4ff] transition-colors text-sm cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white/30 text-xs uppercase tracking-[2px] font-semibold mb-5">Firma</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/45 hover:text-[#00d4ff] transition-colors text-sm cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/30 text-xs uppercase tracking-[2px] font-semibold mb-5">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#00ff88] text-sm" />
                </div>
                <a
                  href="tel:+48600601093"
                  className="text-white/45 hover:text-[#00d4ff] transition-colors text-sm cursor-pointer"
                >
                  +48 600 601 093
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#ff6b9d] text-sm" />
                </div>
                <a
                  href="mailto:kontakt@orsonet.pl"
                  className="text-white/45 hover:text-[#00d4ff] transition-colors text-sm cursor-pointer"
                >
                  kontakt@orsonet.pl
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#00d4ff] text-sm" />
                </div>
                <span className="text-white/45 text-sm">Pon–Pt: 9:00–18:00</span>
              </li>
            </ul>

            <Link
              to="/kontakt"
              className="mt-8 flex items-center justify-center gap-2 py-3 px-5 rounded-xl text-sm font-bold text-black cursor-pointer hover:scale-105 transition-transform shadow-[0_0_20px_rgba(0,212,255,0.25)]"
              style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
            >
              <i className="ri-calendar-check-line" />
              Bezpłatna konsultacja
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <img
              src="https://storage.readdy-site.link/project_files/c74744eb-3995-40db-8fce-b59523b1b313/898a52d7-18aa-43c2-be1f-5134a7f25dee_ChatGPT-Image-24-mar-2026-07_22_57.png?v=a14bd4da0532dd836168e272800ed8fb"
              alt="Orsonet"
              className="h-7 w-auto object-contain opacity-25"
              style={{ maxWidth: '90px' }}
            />
            <p className="text-white/20 text-xs">© 2026 Orsonet. Wszelkie prawa zastrzeżone.</p>
          </div>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 transition-colors text-xs cursor-pointer">Polityka prywatności</a>
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 transition-colors text-xs cursor-pointer">Regulamin</a>
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 transition-colors text-xs cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
